const PREFIX = "COMMON_SURVEY";

export const commonActionTypes = {
  discard: `${PREFIX}_DISCARD`,
};
